import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import HowItWorks from "@/pages/HowItWorks";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/how-it-works")({
  head: () => ({
    meta: [
      { title: "How AI Predictions Work: Our Method | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["faq", "aiPredictions"] }).meta },
      { name: "description", content: "A transparent look at how Statlign turns sports data into explainable predictions — the multi-strategy engine, data enrichment, confidence scoring, and its limits." },
      { property: "og:title", content: "How AI Predictions Work: Our Method | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "A transparent look at how Statlign turns sports data into explainable predictions — the multi-strategy engine, data enrichment, confidence scoring, and its limits." },
      { name: "twitter:title", content: "How AI Predictions Work: Our Method | Statlign" },
      { name: "twitter:description", content: "A transparent look at how Statlign turns sports data into explainable predictions — the multi-strategy engine, data enrichment, confidence scoring, and its limits." },
    ],
  }),
  component: () => (
    <MainLayout>
      <HowItWorks />
    </MainLayout>
  ),
});
